import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk/global'; 
import * as S3 from 'aws-sdk/clients/s3'; 
import { getLocaleCurrencyName } from '@angular/common';

@Injectable({
    providedIn: 'root'
})


export class UploadService {

    public objectKey :string ;

    constructor (){
        this.objectKey = "Bubishi";
    }
    ngOnDestroy (){
        // console.log ("Cleaning up service");

    }

    /**
     * Used to upload profile picture into S3 bucket.
    */
    uploadFile(file: any) {

        // console.log (this.objectKey);

        // const contentType = file.type ; 

        const bucket = new S3(
              {
                  accessKeyId: 'AKIAJZQQRWA5MTFVYY4A', 
                  secretAccessKey: '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',
              }
          );
          const params = {
              Bucket: 'cherymaupps3gradebookexample',
              Key: file.name,
              Body: file,
              ACL: 'public-read',
            //   ContentType: contentType
          };

          // Uploading the file into S3 bucket
          bucket.upload(params, function (err, data) {
              
              if (err) {
                //   console.log('There was an error uploading your file: ', err);
                  return false;
              }
            //   console.log('Successfully uploaded file.', data);
            //   console.log("This is the Location Key "+ data.Location);

              this.objectKey = "Testing this should work";  
            //   console.log (this.objectKey);

              return true;     
          });   
          
    }
}